var zipcode = {
    init: function(){
        if ($(':input[name="invoice_address[land]"]').length > 0){
            zipcode.handle(
                $(':input[name="invoice_address[land]"]'),
                $(':input[name="invoice_address[straat]"]'),
                $(':input[name="invoice_address[huisnummer]"]'),
                $(':input[name="invoice_address[postcode]"]'),
                $(':input[name="invoice_address[plaats]"]'),
                'invoice_address');
        }
        if ($(':input[name="shipping_address[land]"]').length > 0){
            zipcode.handle(
                $(':input[name="shipping_address[land]"]'),
                $(':input[name="shipping_address[straat]"]'),
                $(':input[name="shipping_address[huisnummer]"]'),
                $(':input[name="shipping_address[postcode]"]'),
                $(':input[name="shipping_address[plaats]"]'),
                'shipping_address');
        }
        if ($(':input[name="delivery_address[land]"]').length > 0){
            zipcode.handle(
                $(':input[name="delivery_address[land]"]'),
                $(':input[name="delivery_address[straat]"]'),
                $(':input[name="delivery_address[huisnummer]"]'),
                $(':input[name="delivery_address[postcode]"]'),
                $(':input[name="delivery_address[plaats]"]'),
                'delivery_address');
        }

    },
    handle: function(country, street, houseNumber, postcode, city, className){
        if (country.val() === 'NL'){
            street.prop('readonly', true).prop('placeholder', 'Wordt automatisch aangevuld');
            city.prop('readonly', true).prop('placeholder', 'Wordt automatisch aangevuld');;
        } else {
            street.prop('readonly', false).prop('placeholder', 'Straat');
            city.prop('readonly', false).prop('placeholder', 'Plaats');
        }
        postcode.addClass(className);
        houseNumber.addClass(className);
        country.off('change').change(function(){
           zipcode.handle(country, street, houseNumber, postcode, city, className);
        });
        $("." + className).off('change').change(function(){
            if (postcode.val().length > 0 && houseNumber.val().length > 0){
                $.fancybox.showLoading();
                street.prop("placeholder","Adres wordt opgezocht ...");
                city.prop("placeholder", "Adres wordt opgezocht ...");
                jQuery.post(window.location, {action:'getAddress', postcode:postcode.val(), huisnummer:houseNumber.val()}, function(data){
                    if(data.invalid){
                        street.val('');
                        city.val('');
                        street.attr('placeholder', data.street);
                        city.attr('placeholder', data.city);
                    } else {
                        street.val(data.street);
                        city.val(data.city);
                        street.next('.form__label-check').show();
                        city.next('.form__label-check').show();
                    }
                    jQuery.fancybox.hideLoading();
                },'json');
            }
        })
    }
};

$(function(){
    zipcode.init();
});